import { MotorsportsCalendarRowData, MotorsportsCurrentCalendarProps, MotorsportsSessionRowSession } from '@sky-it-livedata/livedata-sports-design-system';

import { currentCalendarTrackingData } from '../helpers/tracking-data';
import { CurrentCalendarQuery } from '../types';
import { isValidCurrentCalendar } from './typeguards';
import { CreateGpCurrentCalendarWidgetInputSchema, GpCalendarGpInfo, GpCalendarItem, GpCalendarItemSessions } from 'appsync';
import { ErrorName, WidgetError } from '../../../utils/errors';
import { buildGPSessionsByDate, filterSessions, getGPEndDate, getGPStartDate } from '../../../utils/session';
import { RaceSessionStatus, RaceSessionType } from '../../../types/race-session';


const currentCalendarTransformer = (obj: CurrentCalendarQuery): MotorsportsCurrentCalendarProps => {
  if (isValidCurrentCalendar(obj)) {
    CreateGpCurrentCalendarWidgetInputSchema().parse(obj.data.getGpCurrentCalendarWidget, {reportInput: true});

    const gpItems = obj.data.getGpCurrentCalendarWidget?.items || [];

    const sessions = gpItems
      .filter((item): item is GpCalendarItem => Boolean(item && (item as GpCalendarItem).gpInfo))
      .map((item: GpCalendarItem) => {
        const { gpInfo, sessions } = item;
        const {
          circuitUrl,
          customGpName,
          flagUrl,
          gpPageUrl,
          isCurrent,
          isExclusive: isExclusiveLive,
          laps,
          lengthKm,
        } = gpInfo as GpCalendarGpInfo;
        
        const transformedSessions = (sessions as GpCalendarItemSessions).items?.map((sessionObj) => {
          const session = sessionObj;
          const { sessionLabel: sessionName, sessionStatus, sessionInfo, sessionResultUrl } = session || {};
          
          return {
            sessionName: sessionName as RaceSessionType,
            sessionStatus: sessionStatus as RaceSessionStatus,
            sessionResultUrl,
            sessionDate: sessionInfo?.startDateTime as string| undefined,
          };
        }).filter(filterSessions) as MotorsportsSessionRowSession[]; // Filter STARTING_GRID and OTHER SESSIONS...

        const gpSessions = buildGPSessionsByDate(transformedSessions) || []; // Sort SESSION by DATE/TIME

        return {
          circuitUrl: circuitUrl ?? '',
          dateEnd: getGPEndDate(gpSessions),
          dateStart: getGPStartDate(gpSessions) || undefined,
          distance: lengthKm ?? '-',
          flagUrl: flagUrl ?? '',
          gpPageUrl: gpPageUrl ?? '',
          isCurrent: isCurrent ?? false,
          isExclusiveLive: isExclusiveLive ?? false,
          laps: laps ?? '-',
          name: customGpName,
          sessions: gpSessions,
        };
      });
    return {
      sessions: sessions as MotorsportsCalendarRowData[],
      customTrackingData: currentCalendarTrackingData,
    };

  } else {
      throw new WidgetError<ErrorName>({
        name: 'NO_VALID_DATA',
        message: 'Invalid transformer input, Error in CurrentCalendarQuery object',
        data: obj
      });
    }
};

export default currentCalendarTransformer;
